import { forwardRef, useCallback } from "react"
import { cn } from "@ui/utils"

interface NativeVideoPlayerProps {
  src: string
  onTimeUpdate?: (event: Event) => void
  className?: string
}

const NativeVideoPlayer = forwardRef<HTMLVideoElement, NativeVideoPlayerProps>(
  ({ src, onTimeUpdate, className }, ref) => {
    const handleTimeUpdate = useCallback(
      (e: React.SyntheticEvent<HTMLVideoElement>) => {
        onTimeUpdate?.(e.nativeEvent)
      },
      [onTimeUpdate]
    )

    return (
      <video
        ref={ref}
        src={src}
        controls
        className={cn("aspect-video w-full rounded-lg", className)}
        onTimeUpdate={handleTimeUpdate}
      />
    )
  }
)

NativeVideoPlayer.displayName = "NativeVideoPlayer"
export default NativeVideoPlayer
